import React, { useContext } from 'react';
import { default as BootstrapSpinner } from 'react-bootstrap/Spinner';
import LoadingContext from '../context/loading.context';
import ThemeContext from '../context/theme.Context';

const Spinner = () => {
    const { loadingCount } = useContext(LoadingContext);

    return (
        <ThemeContext.Consumer>
            {(themeContext) => (
                <React.Fragment>
                    {loadingCount > 0 &&
                        <BootstrapSpinner variant={themeContext.textColor} animation="border" role="status" size="sm"></BootstrapSpinner>
                    }
                </React.Fragment>
            )}
        </ThemeContext.Consumer>
    );
};

export default Spinner;


// WEBPACK FOOTER //
// ./src/components/Spinner.component.js